import React from "react";
import { Breadcrumbs, Grid, Link, MenuItem, Select} from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { Link as LinkRouter} from "react-router-dom";
import { useParams } from "react-router-dom";
import ProfileSelection from "./components/ProfileSelection";
import { useHistory } from 'react-router-dom';
import TabViewEdit from "./components/TabViewEdit";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function UserSelectionScreen(props) {
  let query = useQuery();
  const roles = [
    {value: 'Student', label: 'Staff/Student'},
    {value: 'Educator', label: 'Managers/Educators'},
  ];
  const courseName = query.get("courseName");
  const role = query.get("role");
  const action = query.get("action");
  const listPage = query.get("listPage");
  const { courseId } = useParams();  
  let history = useHistory();  
  const [selectedRole, setSelectedRole] = React.useState(role);

  const onChangeUrl = (role, action) => {
    history.push({
      pathname: `/dashboard/courses/${courseId}/user-selection`,
      search: `?courseName=${courseName}&role=${role || selectedRole}&action=${action}`,  // query string
      state: {  // location state
        update: true, 
      },
    }); 
  }

  const handleChange = (event) => {
    const selectedValue  = event.target.value;
    setSelectedRole(selectedValue);
    onChangeUrl(selectedValue, action);
  }

  return (
    <div
      id="course-user-selection-screen"
      className={`${props.className} dashboard-container`}
    >
      {/* BreadCrum */}
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          color="inherit"
          component={LinkRouter}
          to={`/dashboard/courses`}>
          Groups
        </Link>
        <Link
          to={{
            pathname: "/dashboard/courses/",
            search: `?page=${listPage}&openedCourseId=${courseId}`
          }}
          color="inherit"
          component={LinkRouter}
          aria-current="page">
          
          {courseName}
        </Link>
        <Link
          to={location => location.pathname}
          color="textPrimary"
          component={LinkRouter}
          aria-current="page">
          User selection
        </Link>
      </Breadcrumbs>
      <br/>

      <Grid container spacing={3} direction="row">
        <Grid item xs={6} sm={6}>
          <h3>{role}s for "{courseName}"</h3>
        </Grid>
        <Grid item xs={6} sm={6}>
          <Select id="demo-simple-select-helper" multiple={false} value={selectedRole} variant="outlined" fullWidth={true} displayEmpty onChange={handleChange} >
            {roles.map(item => (
              <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12}>
          <TabViewEdit 
              action={action}
              role={role}
              viewComponent={<ProfileSelection courseId={courseId} role={selectedRole} action={'View'}/>} 
              AssignComponent={<ProfileSelection courseId={courseId} role={selectedRole} action={'Assign'}/>} 
              onChangeUrl={onChangeUrl}
            />   
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
          
      </div>
  );
}

export default UserSelectionScreen;
